module.exports = __webpack_public_path__ + "img/phone.f321649.svg";